module.exports = __webpack_public_path__ + "img/multiTank_s.6d2d2fc9.png";